import { IEvent, IPlace, IUser, Result } from '~/classes'
import { IOrganization, OrganizationPosition, OrganizationType } from '~/classes/Organization'

export const organizationCreateAPI = async (params: {
  organization: {
    name: string
    email: string
    phone: string
    type: typeof OrganizationType[number]
  },
  user: {
    name: string
    lastname: string
    position: typeof OrganizationPosition[number]
  }
}) => {
  const response: Result<{
    organization: IOrganization
  }> = await fetchAPI('organization/create', { ...params }, { method: 'POST' })

  return response
}

export const organizationEditAPI = async (
  _id: string,
  params: {
    name?: string
    description?: string
    logo?: string
  }
) => {
  const response: Result<{
    organization: IOrganization
  }> = await fetchAPI('organization/edit', { _id, params }, { method: 'POST' })

  return response
}

export const organizationGetMineAPI = async () => {
  const response: Result<{
    organizations: IOrganization[]
    users: IUser[]
  }> = await fetchAPI('organization/mine', {}, { method: 'GET' })

  return response
}

export const organizationGetOneAPI = async (
  organizationId: string,
  options?: FetchOptions
) => {
  const response: Result<{
    organization: IOrganization,
    events: IEvent[]
  }> = await fetchAPI('organization/one', { organizationId, options }, { method: 'POST' })

  return response
}

export const organizationEventsMineAPI = async (params: {
}, options?: FetchOptions) => {
  const response: Result<{
    events: IEvent[]
  }> = await fetchAPI('organization/events/mine', { options }, { method: 'POST' })

  return response
}

export const organizationHomeAPI = async (params: {
}) => {
  const response: Result<{
    events: IEvent[]
    attendeesPerDay: { [key: string]: Date | number }[]
  }> = await fetchAPI('organization/home', {}, { method: 'GET' })

  return response
}

export const organizationGetAPI = async (
  filters: {
    category?: string
  },
  isCount: boolean,
  options: FetchOptions,
  controller?: AbortController
) => {
  const response: Result<{
    organizations: IOrganization[]
    counts: {
      place: number
      event: number
      other: number
      group: number
      individual: number
      independant: number
    }
  }> = await fetchAPI('organization/get', { filters, isCount, options }, { method: 'POST', controller })

  return response
}

export const organizationSubscribeAPI = async (
  organizationId: string,
  params: {
    email: string
    company: {
      name: string
      address: string
      city: string
      country: string
      zipCode: string
      vat: string
    },
    subscription: 'essential_1' | 'essential_12' | 'advanced_1' | 'advanced_12'
    locationId: string
}) => {
  const response: Result<{
    success: boolean
  }> = await fetchAPI('organization/subscribe', { organizationId, ...params }, { method: 'POST' })
  
  return response
}

export const organizationSubscribeCancelAPI = async (
  organizationId: string,
  subscriptionId: string
) => {
  const response: Result<{
    success: boolean
  }> = await fetchAPI('organization/subscribe/cancel', { organizationId, subscriptionId }, { method: 'POST' })
  
  return response
}

export const organizationClaimPaymentAPI = async (
  organizationId: string,
  params: {
    locationId: string
    email: string
    company: {
      name: string
      address: string
      city: string
      country: string
      zipCode: string
      vat: string
    }
  }
) => {
  const response: Result<{
    success: boolean
  }> = await fetchAPI('organization/claim', { organizationId, ...params }, { method: 'POST' })

  return response
}

export const organizationInviteGetAPI = async (
  code: string,
) => {
  const response: Result<{
    organization: IOrganization
  }> = await fetchAPI('organization/invite', { code }, { method: 'POST' })

  return response
}

export const organizationInviteAcceptAPI = async (
  code: string,
) => {
  const response: Result<{
    organization: IOrganization
  }> = await fetchAPI('organization/invite/accept', { code }, { method: 'POST' })

  return response
}

export const organizationPlaceAPI = async () => {
  const response: Result<{
    places: IPlace[]
  }> = await fetchAPI('organization/place', {}, { method: 'POST' })

  return response
}

export const organizationPlaceClaimAPI = async (
  placeId: string
) => {
  const response: Result<{
    success: boolean
  }> = await fetchAPI('organization/place/claim', { placeId }, { method: 'POST' })

  return response
}